(() => {
  let dispose = () => {};
  const initialize = () => {
    dispose();
    if (!document.querySelector('.glide-hero')) return;
    const sections = [...document.querySelectorAll('.product-story-layout-wide')];
    const reveal = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) target.classList.add('glide-revealed');
      });
    }, { threshold: 0.08 });
    sections.forEach((section, index) => {
      section.classList.add('glide-feature');
      const intro = section.querySelector('.product-story-intro');
      intro.dataset.glideStep = String(index + 1).padStart(2, '0');
      reveal.observe(intro);
    });
    document.documentElement.classList.add('glide-motion-ready');
    dispose = () => {
      reveal.disconnect();
      document.documentElement.classList.remove('glide-motion-ready');
    };
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => dispose());
})();
